import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { memo, useMemo } from 'react';
import { UniversalMenuItem } from './item';
import { StyledMenu } from 'shared/components/menu/style';
export const UniversalMenu = memo(function UniversalMenu(props) {
    const { menu_items, universal = true, onClose, opened, anchor, small } = props;
    const show_swipable_menu = !isMediumUI() && universal;
    // TODO: not work with iOS 12
    // const Menu = SwipableMenu;
    const menu_groups = useMemo(() => menu_items.map((menu_item) => {
        const { icon, group_label, label, group_items, onClick, additional_view, show = true, divider, disabled, data_tooltip, } = menu_item;
        if (!show) {
            return null;
        }
        if (group_label && group_items) {
            const group_rows = group_items.map((group_item) => {
                const { icon, additional_view, label: item_label, onClick: onGroupItemClick, } = group_item;
                return (_jsx(UniversalMenuItem, { onClick: onGroupItemClick, disabled: disabled, icon: icon, label: item_label, additional_view: additional_view, type: show_swipable_menu ? 'swipable' : 'default', divider: divider, data_tooltip: data_tooltip }, `${group_label} ${item_label}`));
            });
            return (_jsxs(Box, { display: "flex", flexDirection: "column", mt: 1, children: [_jsx(Typography, { color: "textSecondary", px: 2, mb: 1, children: group_label }), group_rows] }, group_label));
        }
        return (_jsx(UniversalMenuItem, { onClick: onClick, disabled: disabled, icon: icon, label: label, type: show_swipable_menu ? 'swipable' : 'default', divider: divider, data_tooltip: data_tooltip, additional_view: additional_view }, label));
    }), [menu_items]);
    return (_jsx(StyledMenu, { open: opened, onClose: onClose, anchorEl: anchor, small: small, transformOrigin: { vertical: 'top', horizontal: 'left' }, children: menu_groups }));
});
